import { useState } from 'react';
import { InvoicingAddressDialog } from '../../../Common/Dialogs/InvoicingAddress';
import {
  InvoicingAddress,
  InvoicingAddressContextTypes,
} from '../../../Common/Dialogs/InvoicingAddress/types';
import { InvoicingAddressSummary } from './InvoicingAddressSummary';

interface ExistingInvoicingAddressProps {
  invoicingAddress: InvoicingAddress;
  setInvoicingAddress: (address: InvoicingAddress) => void;
  setUpdateCustomerInvoicingAddress: (update: boolean) => void;
}

export const ExistingInvoicingAddress = (
  props: ExistingInvoicingAddressProps,
) => {
  const {
    invoicingAddress,
    setInvoicingAddress,
    setUpdateCustomerInvoicingAddress,
  } = props;
  const [showInvoicingAddressEditDialog, setShowInvoicingAddressEditDialog] =
    useState<boolean>(false);

  return (
    <>
      <InvoicingAddressSummary
        invoicingAddress={invoicingAddress}
        onEditClick={() => setShowInvoicingAddressEditDialog(true)}
      />

      {showInvoicingAddressEditDialog && (
        <InvoicingAddressDialog
          initialData={{
            ...invoicingAddress,
            agreeCnp: !!invoicingAddress.cnp,
          }}
          closeDialog={() => setShowInvoicingAddressEditDialog(false)}
          contextType={InvoicingAddressContextTypes.CartMainAddress}
          onSaveInCart={invoicingAddress => {
            setInvoicingAddress(invoicingAddress);
            setUpdateCustomerInvoicingAddress(true);
          }}
        />
      )}
    </>
  );
};
